import { CompletedListMedicationsAnswer } from "~/common/utils/consultations/screening";

export const formatMedications = (answer: CompletedListMedicationsAnswer[]) =>
  answer.flatMap((med) =>
    med.medications.map(
      (medication) =>
        `${medication.name}, ${medication.dose}, ${medication.frequency}`,
    ),
  );
